import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  isEmpty, noop, map,
} from 'lodash';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { normalizeAmount } from '../../utils/transformer.util';
import {
  Button,
  Select,
  SearchSelect,
  SelectMultiple,
  DuplicateableSelect,
  Input
} from '../../components/base/index';

const MySwal = withReactContent(Swal);

export default class TambahRombel extends Component {
  constructor(props) {
    super(props);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    this._onRemoveMulti = this._onRemoveMulti.bind(this);
    this._onChangeMulti = this._onChangeMulti.bind(this);
    this._onFormChange = this._onFormChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this._getSchoolUnitsOptions = this._getSchoolUnitsOptions.bind(this);
    this._getPrmStaffMasterOptions = this._getPrmStaffMasterOptions.bind(this);
    this._onAddList= this._onAddList.bind(this);
    this._onDeleteList= this._onDeleteList.bind(this);
    this._getParamOptionsAcademics = this._getParamOptionsAcademics.bind(this);

    const { user } = this.props;
    const { school_unit } = user;
    this.state = {
      page: 1,
      filters: {},
      form: {
        value: {
          rombels: [{
            min_rombel:'',
            max_rombel:'',
            min_headcount:'',
            details: []
          }],
        },
        error: {},
      },
      param: {},
    };
  }

  componentDidMount() {
    const {
      location, getLevels, getclassrooms, user,
    } = this.props;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const { school_unit, organizations_id } = user;
    const paramTypes = ['levels'];
    paramTypes.forEach((type) => {
      this._getParamOptionsAcademics(type);
    });


    if (isEdit && data) {
      this._setForm(data);
    }
    // this._getSchoolUnitsOptions();
    this._getPrmStaffMasterOptions();
  }


  async _getPrmStaffMasterOptions(filters = {}) {
    const { getPrmStaffMasterOptions, user } = this.props;
    const { school_unit, user_group } = user;
    const { levels_id } = school_unit;
    const res = await getPrmStaffMasterOptions(filters);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        staff: res,
      },
    }));
  }

  async _getSchoolUnitsOptions(filters = {}) {
    const { getSchoolUnitsOptions } = this.props;
    const { form } = this.state;
    const { units_id } = form.value;
    const res = await getSchoolUnitsOptions(filters);
    const selectedUnits = res.find(item => item.value == units_id);

    // console.log(units_id)
    this.setState(prevState => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          levels_units: selectedUnits ? selectedUnits.attributes.levels_id : '',
        },
      },
      param: {
        ...prevState.param,
        units: res,
      },
    }));
  }

  async _getParamOptionsAcademics(type, filters = {}) {
    const { getParamOptionsAcademics, user } = this.props;
    const { school_unit, organizations_id } = user;
    if (type === 'classrooms' || type === 'classrooms') {
      filters.organizations_id = organizations_id;
      // filters.units_id = school_unit.id;
    } else {
      delete filters.organizations_id;
    }
    const res = await getParamOptionsAcademics(filters, type);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        [type]: res,
      },
    }));
  }
  // componentDidUpdate(prevProps) {
  //   // const { user } = this.props;
  //   // const { workingUnit } = user;
  //   // const { user: prevUser } = prevProps;
  //   // const { workingUnit: prevWorkingUnit } = prevUser;

  //   // if (!isEqual(workingUnit, prevWorkingUnit)) {
  //   //   this.handleGetData();
  //   // }
  //   if (!isEqual(prevProps, this.props)) {
  //     this._onSearchContent({ page: 1 });
  //   }
  // }

  async _setForm(data) {
    const { user } = this.props;
    const { organizations_id } = user;
    const { form } = this.state;
    this._getSchoolUnitsOptions({levels_id: data.levels_id});

    try {
      this.setState({
        form: {
          value: {
            id: data.id,
            levels_id: data.levels_id,
            units_id: data.units_id,
            rombels: map(data.rombels, item => ({
              min_rombel: item.min_rombel,
              max_rombel: item.max_rombel,
              min_headcount: item.min_headcount,
              details: item.details,
              checkbox:item.max_rombel==null?true:false,
              checkbox2:item.min_headcount==null?true:false,
            }))
          },
          error: {},
        },
      });
    } catch (err) {
      // err action
    }
  }

  _onChangeFilter(e) {
    const { target } = e;
    const { value, name } = target;
    const { user } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    if (name === 'user_groups_id') {
      this.setState(prevState => ({
        filters: {
          ...prevState.filters,
          username: '',
        },
      }));
    }
    this.setState(prevState => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        [name]: value,
      },
    }),
    () => {
      if (name === 'perwakilan_id') {
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              perwakilan_id: value,
              units_id: '',
            },
          },
        }));
        this._getSchoolUnitsOptions({ perwakilan_id: value.value });
        // if(value.value == 'all'){
        // this._onSearchContent();
        // }
      }
      if (name === 'units_id') {
        const param = this.state.param.units;
        const levels_units = param.find(i => i.value == value.value)
          ? param.find(i => i.value == value.value).attributes.levels_id
          : '';

        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              classrooms_id: '',
              levels_id: levels_units,
              units_id: value,
            },
          },
        }));
      }
      // this._onSearchContent();
    });
  }

  async onSubmit() {
    const { history, handleSaveRombels } = this.props;
    const { form } = this.state;
    const { value } = form;
    await handleSaveRombels(value);
    history.push('/dashboard/pengaturan/rombel');
  }

  async onEdit() {
    const { history, handleEditRombels } = this.props;
    const { form } = this.state;
    const { value } = form;
    await handleEditRombels(value);
    history.push('/dashboard/pengaturan/rombel');
  }

  _setIsBlocked(isBlocked) {
    const { form, filters, param } = this.state;
    const { value } = form;
    const { rombels, classes_id } = value;
    const newList = JSON.parse(JSON.stringify(rombels));
    newList.forEach((item) => {
      item.is_active = isBlocked;
    });

    this.setState(prevState => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          rombels: newList,
        },
      },
    }));
  }

  _onFormChange(event) {
    const { form, param } = this.state;
    const { details } = form.value;
    const { user } = this.props;
    const { school_unit, organizations_id } = user;
    const {
      name, value, dataset, checked, type,
    } = event.target;
    const {
      inputType = 'text',
      inputArray = false,
      arrayPosition = 0,
      fieldName,
    } = dataset;

    this.setState((prevState) => {
      let newList = [];
      let newListError = [];
      let formattedValue = value;
    //   if (name === 'staff'){
    //     console.log(value)
    //     const selectedStaff = param.staff.find(
    //       (item) => item.value == value.value
    //     )
    //     var parts = selectedStaff.label.split(' - ');
    //     const code = selectedStaff.label.split(' - ')[0].trim();
    // const staff_name = parts.length > 1 ? parts[1].trim() : '';
    // form.value.name = staff_name;
    // form.value.code = code;
    //   }
      if (inputType === 'number') {
        formattedValue = normalizeAmount(value);
      }
      if (inputArray) {
        if (type === 'checkbox') {
          formattedValue = checked;
        }
        
        newList = prevState.form.value[fieldName] || [];
        newListError = prevState.form.error[fieldName] || [];
        newList[arrayPosition][name] = formattedValue;
        if (name === 'code_of_account') {
          newList[arrayPosition].isCredit = value.type;
        }
        if (!isEmpty(newListError[arrayPosition])) {
          newListError[arrayPosition][name] = '';
        }
       
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            ...(inputArray
              ? { [fieldName]: newList }
              : { [name]: formattedValue }),
          },
          error: {
            ...prevState.form.error,
            ...(inputArray ? { [fieldName]: newListError } : { [name]: '' }),
          },
        },
      };
    },
    () => {
      if (name === 'levels_id') {
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              units_id:'',
              // graduate: param.find(i => i.value == value).attributes.graduate,
            },
          },
        }));
        this._getSchoolUnitsOptions({levels_id: value});
      }
      if (name === 'classes_id') {
        const param = this.state.param.classes_prm;
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              // graduate: param.find(i => i.value == value).attributes.graduate,
            },
          },
        }));
      }
    });
  }

  _onRemoveMulti(selectedList, removedItem, inputArray, fieldName, arrayPosition) {
    this._onFormChange({
      target: {
        name: removedItem,
        value: selectedList,
        dataset: {
          inputArray,
          fieldName,
          arrayPosition,
        },
      },
    });
  }

  _onChangeMulti(value, name, inputArray, fieldName, arrayPosition) {
    this._onFormChange({
      target: {
        name,
        value,
        dataset: {
          inputArray,
          fieldName,
          arrayPosition,
        },
      },
    });
  }

  _onAddList(data){
    const { form } = this.state;
    const { rombels } = form.value;

    rombels.push({
      min_rombel:'',
      max_rombel:'',
      min_headcount:'',
      details: []
    });

    this.setState(prevState => ({
      form: {
        value: {
          ...prevState.form.value,
          rombels,
        },
        error: {
          ...prevState.form.error,
        },
      },
    }));
  }

  _onDeleteList(idx) {
    this.setState((prevState) => {
      const { rombels } = prevState.form.value;
      const list = prevState.form.value.rombels;

      list.splice(idx, 1);
      return {
        ...prevState,
        rombels: list,
      };
    });
  }
  _renderButtons(data) {
    const { user } = this.props;

    return (
      <td>
        <div className="table__actions">
          <Button onClick={() => this.onClickEdit(data)} title="Edit" />
        </div>
      </td>
    );
  }

  onClickAdd() {
    const { history } = this.props;
    history.push('/dashboard/pengaturan/tambah-master-mapel', {
      // isEdit: true,
      // data: { units_id: units_id},
    });
  }

  handleSelectionChange = (items) => {
    console.log("Selected items:", items);
  };

  render() {
    const {
      location, getLevels, getclassrooms, user,
    } = this.props;
    const { form, filters, param } = this.state;
    const { rombels } = form.value;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const dataGet = data || '';
    
    return (
      <div className="manage-registration">
        <h1>Tambah Pengaturan Rombel</h1>
        <hr />
        <div className="absensi-rekap__custom-form">
          <div className="absensi-rekap__custom-form-row">
            {/* <div className="absensi-rekap__custom-form-row__field"> */}
            
              <Select
                type="text"
                name="levels_id"
                label="Pilih Jenjang"
                placeholder={"Pilih Jenjang"}
                data={param.levels}
                onChange={this._onFormChange}
                value={form.value.levels_id}
                // disabled
              />
            </div>
                <p>Pilih Unit *</p>
               <SelectMultiple
                  name="units_id"
                  style={{ width: '50%' }}
                  options={param.units}
                  displayValue="label" // Property name to display in the dropdown options
                  showCheckbox
                  values={form.value.units_id}
                  onRemove={value => this._onRemoveMulti(value, 'units_id')}
                  onSelect={value => this._onChangeMulti(value, 'units_id')}
                />
            {/* </div> */}
        </div>
        <div className="manage-registration">
          <div className="fund-request__content">
            <table className="table">
              <thead>
                <tr style={{textAlign:"center"}}>
                  <th>No</th>
                  <th style={{width:'20%'}}>Min Rombel</th>
                  <th style={{width:'20%'}}>Max Rombel</th>
                  <th style={{width:'20%'}}>Total Siswa</th>
                  <th style={{width:'40%'}}>Pilih Jabatan</th>
                  <th>Opsi</th>
              </tr>
              </thead>
              <tbody>
                {map(rombels, (list, idx) => (
                    <tr key={`plafon_journal_data__${idx}`}>
                      <td style={{ textAlign: 'center' }}>
                        {idx + 1}.
                      </td>
                      <td>
                         <Input
                          type="number"
                          name="min_rombel"
                          // label={`Cicilan ${idx + 1} *`}
                          onChange={this._onFormChange}
                          value={list.min_rombel}
                          // error={form.error.dp}
                          error={list.errmin}
                          data-input-array
                          arrayPosition={idx}
                          data-array-position={idx}
                          data-field-name="rombels"
                          isNumber
                          isRequired
                        />
                       
                      </td>
                      <td>
                        <div className="manage-registration__custom-form-row__field">

                          <Input
                          style ={{width:'200%'}}

                            type="number"
                            name="max_rombel"
                            // label={`Cicilan ${idx + 1} *`}
                            onChange={this._onFormChange}
                            value={list.max_rombel}
                            // error={form.error.dp}
                            error={list.errmax}
                            data-input-array
                            arrayPosition={idx}
                            data-array-position={idx}
                            data-field-name="rombels"
                            disabled={list.checkbox == true ? true : false}
                            isNumber
                            isRequired
                          />
                          <div className="manage-registration__custom-form-row-datadiri">
                        
                           <Input
                            type="checkbox"
                            name="checkbox"
                            data-input-array
                            data-array-position={idx}
                            data-field-name="rombels"
                            onChange={this._onFormChange}
                                // checked={list.checkbox}
                            checked={list.checkbox == true}
                            value={list.checkbox ? list.checkbox : false}
                          />{' '}
                        </div>
                        </div>
                        <p style={{fontSize:12}}>Centang Jika Nilai Kosong</p>
                      </td>
                      <td>
                        <div className="manage-registration__custom-form-row__field">

                         <Input
                          type="number"
                          name="min_headcount"
                          onChange={this._onFormChange}
                          value={list.min_headcount}
                          // error={form.error.dp}
                          error={list.errhead}
                          data-input-array
                          arrayPosition={idx}
                          data-array-position={idx}
                          data-field-name="rombels"
                          disabled={list.checkbox2 == true ? true : false}
                          isNumber
                          isRequired
                        />
                          <div className="manage-registration__custom-form-row-datadiri">

                          <Input
                            type="checkbox"
                            name="checkbox2"
                            data-input-array
                            data-array-position={idx}
                            data-field-name="rombels"
                            onChange={this._onFormChange}
                                // checked={list.checkbox}
                            checked={list.checkbox2 == true}
                            value={list.checkbox2 ? list.checkbox2 : false}
                          />{' '}
                          </div>
                          </div>
                          <p style={{fontSize:12}}>Centang Jika Nilai Kosong</p>
                      </td>
                      <td>
                          {/* <SelectMultiple
                            name="details"
                            style={{ width: '50%' }}
                            options={param.staff}
                            // label="Hari"
                            // displayValue="label" // Property name to display in the dropdown options
                            showCheckbox
                            inputArray
                            fieldName="rombels"
                            array_position={idx}
                            values={list.details}
                            onRemove={value => this._onRemoveMulti(value, 'details', true, 'rombels', idx)}
                            onSelect={value => this._onChangeMulti(value, 'details', true, 'rombels', idx)}
                          /> */}
                          <DuplicateableSelect 
                          options={param.staff} 
                          onChange={value => this._onChangeMulti(value, 'details', true, 'rombels', idx)}
                           name="details"
                            style={{ width: '50%' }}
                            // label="Hari"
                            // displayValue="label" // Property name to display in the dropdown options
                            showCheckbox
                            inputArray
                            fieldName="rombels"
                            array_position={idx}
                            values={list.details} />
                      </td>
                        <td>
                          <Button
                            onClick={() => this._onDeleteList(idx)}
                            icon="icon-trash-o"
                          />
                        </td>
                    </tr>
                ))}
                  <tr className="manage-rapbs-plafon__add-more">
                    <td colSpan={10}>
                      <div>
                        <Button
                          icon="icon-plus"
                        onClick={this._onAddList}
                        />
                      </div>
                    </td>
                  </tr>
              </tbody>
            </table>
             <div className="student-list__button2">
                {form.value.id
                  ? (
                    <Button
                      type="button"
                      title="Update"
                      onClick={this.onEdit}
                    />
                  )
                  : (
                    <Button
                      type="button"
                      title="Simpan"
                      onClick={this.onSubmit}
                    />
                  )
                  }
              </div>
          </div>
        </div>
      </div>
    );
  }
}
TambahRombel.propTypes = {
  handleGetStudent: PropTypes.func,
  handleDeleteStudent: PropTypes.func,
  history: PropTypes.object.isRequired,
};
TambahRombel.defaultProps = {
  handleGetStudent: noop,
  handleDeleteStudent: noop,
};
